<h2 mat-dialog-title translate>dialog.passwordRecovery.recoverPassword</h2>
<mat-divider class="dialog__divider--top"></mat-divider>
<mat-dialog-content>
  <form [formGroup]="passwordRecoveryForm">
    <mat-grid-list cols="10" rowHeight="10px">
      <mat-grid-tile colspan="10" rowspan="5">
        <div fxFlex fxLayout="row" fxLayoutAlign="start center">
          <p translate>dialog.passwordRecovery.writeUser</p>
        </div>
      </mat-grid-tile>
      <mat-grid-tile colspan="7" rowspan="6">
        <div fxFlex fxLayout="row" fxLayoutAlign="start center">
          <mat-form-field appearance="outline">
            <mat-label translate>mat.form.field.username.placeholder</mat-label>
            <input id="userPasswordRecoveryDialog" type="text" matInput formControlName="user" autocomplete="off" />
          </mat-form-field>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </form>
</mat-dialog-content>
<mat-divider class="dialog__divider--top"></mat-divider>
<mat-dialog-actions>
  <button id="closeButtonPasswordRecoveryDialog" mat-stroked-button color="accent" class="btnMobile" mat-dialog-close>
    <span>{{ 'dialog.password.button2' | translate | uppercase }}</span>
  </button>
  <button
    id="acceptButtonPasswordRecoveryDialog"
    mat-flat-button
    color="accent"
    class="btnMobile"
    [disabled]="!passwordRecoveryForm.valid"
    (click)="accept()"
  >
    <span style="text-transform: uppercase" translate>dialog.passwordRecovery.send</span>
  </button>
</mat-dialog-actions>
